<template>
  <div style="height: 100%;">
    <el-menu background-color="#545c64"
             text-color="#ffffff"
             active-text-color="#ffd04b"
             class="el-menu-vertical-demo"
             :unique-opened="true"
             router>
      <el-submenu :index="item.path"
                  v-for="item in menuData"
                  :key="item.name">
        <template slot="title"><i :class="item.icon"
             style="margin-left:-30px"></i><span>{{item.name}}</span></template>
        <el-menu-item :index="child.path"
                      v-for="child in item.child"
                      :key="child.name">
          <i :class="child.icon"></i>{{child.name}}
        </el-menu-item>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: 'Aside',
  computed: {
    menuData: {
      get () {
        return this.$store.state.menuData
      }
    }
  }
}
</script>

<style scoped>
.el-menu-vertical-demo {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/common/Aside.vue